import { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import Layout from "components/Layout";

import LeadListContainer from "./LeadListContainer";
import MailingListDataContainer from "./MailingListDataContainer";

const MailingList = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;

  margin: 0 0 50px;
  padding: 0 28px;

  display: flex;
  flex-direction: column;

  @media (max-width: ${globalConstants.switchTablet}) {
    margin: 0;
    padding: 0;
  }
`;

export default () => {
  const [searchParams] = useSearchParams();

  // set page Title
  useEffect(() => {
    document.title = "Mailing List | Scalelup";
  }, []);

  const listId = searchParams.get("id") ? searchParams.get("id") : null;

  return (
    <Layout>
      <MailingList>
        <MailingListDataContainer listId={listId} />
        <LeadListContainer listId={listId} />
      </MailingList>
    </Layout>
  );
};
